import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  useDeviceUserListMutation,
  useLazyViewUserQuery,
  useMembersAddMutation,
  useMembersCheckMutation,
  useMembersListMutation,
} from "../../redux/api/api";
import { Table } from "../../../components/Table/Table";
import apiRequest from "../../redux/api/apiRequest";
import { eye_icon, profile } from "../../../assets/imgs";
import CancelIcon from "@mui/icons-material/Cancel";
import { EMAIL, isValidEmail, PASS } from "../../redux/api/Constants";
import { cityList, countriesList, stateList } from "../../redux/api/Country";

const CompanyMembersList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [pagination, setPagination] = useState("");
  const [device, setDevice] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [email, setEmail] = useState("");
  const [emailAvail, setEmailAvail] = useState("");
  const [page, setPage] = useState(1);
  const [ID, setId] = useState("");
  const [imageUrl, setImageUrl] = useState(false);
  const [error, setError] = useState(false);
  const [popup, setPopup] = useState(false);
  const [userData, setUserData] = useState({
    // email: "",
    name: "",
    phone: "",
    password: "",
    password_confirmation: "",
    city: "",
    state: "",
    country: "",
  });

  const [countryId, setCountryId] = useState("");
  const [stateId, setStateId] = useState("");
  const [cityId, setCityId] = useState("");
  console.log(countryId, stateId, Number(cityId));
  const [type, setType] = useState();
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);

  const DeviceId = location?.state?.data?.id;
  console.log("dedviceid", DeviceId);

  // RTK QUERY
  const [viewUser] = useLazyViewUserQuery();
  const [membersList] = useMembersListMutation();
  const [membersAdd] = useMembersAddMutation();
  const [membersCheck] = useMembersCheckMutation();

  const getList = async (id, search) => {
    const formdata = new FormData();
    formdata.append("device_id", id);
    formdata.append("rows", 10);
    formdata.append("page", page);
    formdata.append("search", search ? search : "");
    formdata.append("order", "asc");
    const res = await apiRequest(membersList, formdata, id);
    console.log("idd", id);

    if (res?.status == "success") {
      setList(res?.assigned_users);
      setPagination(res?.pagination_meta);
    }
  };

  const Add = async (id) => {
    console.log("userdata", userData);
    if (
      !userData?.name ||
      userData?.phone?.length < 8 ||
      !email ||
      !email.match(EMAIL) ||
      !userData?.city ||
      !userData?.state ||
      !userData?.country
    ) {
      setError(true);
      return;
    }
    if (!emailAvail) {
      if (!userData?.password || !userData?.password_confirmation) {
        setError(true);
        return;
      }
    }

    setError(false);
    const formdata = new FormData();
    if (type == "edit") {
      formdata.append("user_id", userData?.id);
    }
    formdata.append("name", userData?.name);
    formdata.append("email", email);
    formdata.append("phone", userData?.phone);
    formdata.append("city", userData?.city);
    formdata.append("state", userData?.state);
    formdata.append("country", userData?.country);
    if (!emailAvail) {
      formdata.append("password", userData?.password);
      formdata.append("password_confirmation", userData?.password_confirmation);
    }
    setLoader(true);
    const res = await apiRequest(membersAdd, formdata, id);
    setLoader(false);
    setPopup(false);
    setEditMode(false);
    if (res?.status == "success") {
      toast.success(res?.message);
    } else {
      toast.error("Error");
    }
    setUserData({});
    getList(DeviceId);
  };

  const checkMail = async () => {
    if (!email || !email.match(EMAIL)) {
      setError(true);
      return;
    }
    setError(false);
    const formdata = new FormData();
    formdata.append("email", email);
    setLoader(true);
    const res = await apiRequest(membersCheck, formdata);
    setLoader(false);
    if (res?.status == "success") {
      if (res?.data) {
        setEmailAvail(true);
        setType("view");
      } else {
        setEmailAvail(false);
      }
      setMemberData(res?.data);
      // setUserData({ ...userData, email: res?.data?.email });
      let country = countriesList?.find(
        (item) => item?.name == res?.data?.country
      );
      let state = stateList?.find((item) => item?.name == res?.data?.state);
      let city = cityList?.find((item) => item?.name == res?.data?.city);
      console.log(city, state, country);
      setEmail(res?.data?.email);
      setUserData(res?.data);
      setCityId(Number(city?.id));
      setStateId(Number(state?.id));
      setCountryId(Number(country?.id));
      toast.success(res?.message);
    } else if (res?.message === "Email is available.") {
      setUserData({});
      setEmail("");
      setCityId("");
      setStateId("");
      setCountryId("");
      setError(false);
    } else {
      toast.error("Error");
    }
  };

  const handleSelect = (e) => {
    const { name, value } = e.target;
    let val = (
      name == "country" ? countriesList : name == "state" ? stateList : cityList
    )?.find((item) => {
      if (item?.id == value) {
        return true;
      }
    });
    if (name == "country") {
      setCountryId(Number(value));
      setStateId("");
      setCityId("");
    } else if (name == "state") {
      setStateId(Number(value));
      setCityId("");
    } else {
      setCityId(Number(value));
    }

    console.log(val, name, value);
    setUserData((prevState) => ({
      ...prevState,
      [name]: val?.name,
    }));
  };

  // const userView = async (id) => {
  //   setPopup(true);
  //   const res = await apiRequest(viewUser, id);
  //   if (res?.status == "success") {
  //     setUserData(res?.data);
  //     let country = countriesList?.find(
  //       (item) => item?.name == res?.data?.country
  //     );
  //     let state = stateList?.find(
  //       (item) => item?.name == res?.data?.state
  //     );
  //     let city = cityList?.find((item) => item?.name == res?.data?.city);
  //     console.log(city, state, country);
  //     setCityId(Number(city?.id));
  //     setStateId(Number(state?.id));
  //     setCountryId(Number(country?.id));
  //   }
  //   console.log(res);
  // };

  useEffect(() => {
    let data = location?.state?.data;
    console.log(data);
    if (data) {
      setDevice(data?.device_name);
      setId(data?.id);
      getList(DeviceId);
    }
  }, [page]);

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    // if (name === "email") {
    //   setError((prev) => ({
    //     ...prev,
    //     emailErr: !isValidEmail(value) ? "Please enter a valid Email" : "",
    //   }));
    // }
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },
      {
        Header: "Photo",
        accessor: "profile_url",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => {
                if (!value) {
                  return;
                }
                setImageUrl(value);
              }}
            >
              <img
                src={value ? value : profile}
                className="vip-image pointer"
              />
            </div>
          );
        },
      },
      {
        Header: " Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Number",
        accessor: "phone",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value ? value : "--"}</p>;
        },
      },
      {
        Header: " state",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p>{value ? value : "--"}</p>;
        },
      },
      {
        Header: " Country",
        accessor: "country",
        Cell: ({ value, row }) => {
          return <p>{value ? value : "--"}</p>;
        },
      },
    ],
    [page]
  );

  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
          Member List
        </h2>
        <button
          onClick={() => {
            setPopup(true);
            setType("add");
          }}
          className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
        >
          {" "}
          + Add Member
        </button>
      </div>
      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mt-2 ">
        Device Name :{" "}
        <span className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary1">
          {device}
        </span>
      </h2>

      <div className="d-flex ac-js mt-2 ">
        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary me-3">
          Search
        </h4>
        <input
          type="text"
          className="input-pop ps-2"
          placeholder=" Search"
          onChange={(e) => {
            getList(ID, e.target.value);
          }}
        />
      </div>

      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary mt-2 ">
        Member Count :{" "}
        <span className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary1">
          {list?.length < 10 ? `0${list?.length}` : list?.length}
        </span>
      </h2>
      <Table
        columns={columns}
        data={list}
        show={true}
        pagecount={pagination}
        setPageno={setPage}
      />

      {imageUrl && (
        <div className="image-popup-design">
          <div className="img-popup">
            <div
              className="d-flex ac-je w-100 pointer"
              onClick={() => setImageUrl(false)}
            >
              <HighlightOffIcon />
            </div>
            <img src={imageUrl} className="image-pop" alt="" />
          </div>
        </div>
      )}

      {popup && (
        <div className="popup-design">
          <div className="popup">
            <div className="d-flex ac-jb">
              <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
                Add Members
              </h2>
              <button
                onClick={() => {
                  if (editMode) {
                    setEditMode(false);
                  }
                  setPopup(false);
                  setLoader(false);
                  setUserData({});
                  setEmail("");
                  setCityId("");
                  setStateId("");
                  setCountryId("");
                  setError(false);
                }}
                className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
              >
                <CancelIcon />
              </button>
            </div>

            <div>
              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                Email
              </h4>

              <div className="d-flex gap-2">
                <input
                  type="email"
                  className="input-pop ps-2 w-100"
                  placeholder=" Email Address"
                  name="email"
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  value={email}
                />
                <button
                  onClick={() => {
                    checkMail();
                  }}
                  className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 white add-btn "
                >
                  Check
                </button>
              </div>
              {error && (!email || !email?.match(EMAIL)) && (
                <p className="err">Enter Valid Email</p>
              )}

              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                Name
              </h4>
              <input
                type="text"
                className="input-pop ps-2 w-100"
                placeholder=" Name"
                name="name"
                onChange={(e) => {
                  handleUpdate(e);
                }}
                value={userData?.name || ""}
                disabled={type == "view" ? true : false}
              />
              {error && !userData?.name && <p className="err">Enter Name</p>}
              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                Phone Number (Singapore)
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                placeholder="Phone Number (Singapore)"
                name="phone"
                onChange={(e) => {
                  if (e.target.value.length <= 8) {
                    handleUpdate(e);
                  }
                }}
                value={userData?.phone || ""}
                disabled={type == "view" ? true : false}
              />
              {error && userData?.phone?.length < 8 && (
                <p className="err">Enter Valid Phone Number (Singapore)</p>
              )}
            </div>
            {type != "view" && (
              <div>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Password
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn  w-90"
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={userData?.password}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  (userData?.password?.length < 8 ||
                    !userData?.password?.match(PASS)) && (
                    <p className="err">
                      {!userData?.password
                        ? "Enter Your password"
                        : !userData?.password?.match(PASS)
                        ? "Must include one special char & capital leteer"
                        : "Enter Minimum 8 Charactors"}
                    </p>
                  )}
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Confirm Password
                </h4>
                <div className="input-pop mb-2 w-100 d-flex ac-jb">
                  <input
                    type={visible ? "text" : "password"}
                    maxLength={20}
                    className="cust-btn w-90"
                    placeholder=" Confirm Password"
                    name="password_confirmation"
                    autoComplete="off"
                    onChange={(e) => {
                      handleUpdate(e);
                    }}
                    value={userData?.password_confirmation}
                  />
                  <img
                    src={eye_icon}
                    onClick={() => setVisible(!visible)}
                    className="eye-icon pointer"
                    alt=""
                  />
                </div>
                {error &&
                  (userData?.password_confirmation?.length < 8 ||
                    userData?.password != userData?.password_confirmation) && (
                    <p className="err">
                      {!userData?.password_confirmation
                        ? "Enter Confirm Password"
                        : userData?.password_confirmation?.length < 8
                        ? "Enter Minimum 8 Charactors"
                        : "Password Mismatch"}
                    </p>
                  )}
              </div>
            )}
            <div>
              <div>
                <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                  Country
                </h4>
              </div>
              <select
                className="input-pop ps-2 w-100"
                name="country"
                onChange={(e) => {
                  handleSelect(e);
                }}
                value={countryId}
                disabled={type == "view" ? true : false}
              >
                <option value={""}> -- Select --</option>
                {countriesList?.map((item) => {
                  return <option value={item?.id}> {item?.name}</option>;
                })}
              </select>
              {error && !userData?.country && (
                <p className="err">Enter Country</p>
              )}
              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                State
              </h4>
              <select
                className="input-pop ps-2 w-100"
                name="state"
                onChange={(e) => {
                  handleSelect(e);
                }}
                value={stateId}
                disabled={type == "view" || !countryId ? true : false}
              >
                <option value={""}> -- Select --</option>
                {stateList
                  ?.filter((data) => data?.country_id == countryId)
                  ?.map((item) => {
                    return <option value={item?.id}> {item?.name}</option>;
                  })}
              </select>
              {error && !userData?.state && <p className="err">Enter State</p>}
              <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                City
              </h4>
              <select
                className="input-pop ps-2 w-100"
                name="city"
                onChange={(e) => {
                  handleSelect(e);
                }}
                value={cityId}
                disabled={
                  type == "view" || !countryId || !stateId ? true : false
                }
              >
                <option value={""} className="">
                  {" "}
                  -- Select --
                </option>
                {cityList
                  ?.filter((data) => data?.state_id == stateId)
                  ?.map((item) => {
                    return <option value={item?.id}> {item?.name}</option>;
                  })}
              </select>
              {error && !userData?.city && <p className="err">Enter City</p>}

              {type == "view" && (
                <div>
                  {userData?.devices?.map((item, index) => {
                    return (
                      <div key={index} className="d-flex sm-flex-column">
                        <div>
                          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Device {index + 1}
                          </h4>
                          <input
                            type="text"
                            className="input-pop ps-2 w-90"
                            placeholder="Device"
                            value={item?.device_name}
                            disabled
                          />
                        </div>
                        <div>
                          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            Location
                          </h4>
                          <input
                            type="text"
                            className="input-pop ps-2 w-90"
                            placeholder="Location"
                            value={item?.location_name}
                            disabled
                          />
                        </div>
                        <div>
                          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
                            No of Members
                          </h4>
                          <input
                            type="text"
                            className="input-pop ps-2 w-80"
                            placeholder="20"
                            value={item?.members_count}
                            disabled
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* {type != "view" && ( */}
              <div className="d-flex ac-jc mt-3">
                <button
                  onClick={() => {
                    Add(DeviceId);
                  }}
                  className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                >
                  {loader && (
                    <div
                      class="spinner-border spinner-border-sm "
                      role="status"
                      style={{ marginRight: "5px" }}
                    ></div>
                  )}
                  Submit
                </button>
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default CompanyMembersList;
